import {InnerFilters} from 'types';
import {RemarkingAuditParams} from 'types/remarking-audit';

export const mapRemarkingAuditFilters = (filters: InnerFilters): RemarkingAuditParams => {
    const text = (key: string) => {
        const item = filters[key];
        const value = item && typeof item === 'object' && 'value' in item ? item.value : item;
        return typeof value === 'string' ? value.trim() || undefined : undefined;
    };
    const [from, to] = (filters.eventTimestamp as [Date | null, Date | null]) || [];
    return {
        userRole: text('userRole'),
        userFullName: text('userFullName'),
        organizationName: text('organizationName'),
        organizationTin: text('organizationTin'),
        eventType: text('eventType'),
        documentId: text('documentId'),
        productCode: text('productCode'),
        oldMarkingCode: text('oldMarkingCode'),
        newMarkingCode: text('newMarkingCode'),
        remarkingReason: text('remarkingReason'),
        sourceFormation: text('sourceFormation'),
        from: from
            ? new Date(from.getFullYear(), from.getMonth(), from.getDate()).toISOString()
            : undefined,
        to: to
            ? new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59, 59, 999).toISOString()
            : undefined,
    };
};
